module.exports = __webpack_public_path__ + "img/ewm.4c75928c.png";